import _ from 'lodash'

type CONFIG_TYPE = {
    GRAPHQL_API_REST_BASE: string
    SentryCurrentEnv: string
    UseLogger: boolean
    HeapAppId: string
    ReleaseId: string
    SentryDSN: string
    RegionalConfigs: Record<string, any>
    HotjarSiteConfig: string
    APPCUES_APP_ID: string
    MARKETO_APP_ID: string
    GTMID: string
    PDFTRON_PDFNETJS_LIC: string
}

const PARSERS: Record<string, any> = {
    string: (val = '') => String(val || ''),
    boolean: (val = 'false') => String(val) === 'true',
    number: (val = null) => _.toFinite(val) || null,
    json: (val = '{}') => {
        const configs = JSON.stringify(val)

        return JSON.parse(configs) || {}
    },
}

type CONFIG_KEYS = keyof CONFIG_TYPE

const CONFIG_DEFINITION: Record<CONFIG_KEYS, string> = {
    // Env variables
    GRAPHQL_API_REST_BASE: 'string',
    GTMID: 'string',
    SentryCurrentEnv: 'string',
    UseLogger: 'boolean',
    // Parameter store
    HeapAppId: 'string',
    MARKETO_APP_ID: 'string',
    ReleaseId: 'string',
    SentryDSN: 'string',
    RegionalConfigs: 'json',
    HotjarSiteConfig: 'string',
    PDFTRON_PDFNETJS_LIC: 'string',
    APPCUES_APP_ID: 'string',
}

const CONFIG: Partial<CONFIG_TYPE> = {}

let isStarted = false

export function setenv(input: typeof CONFIG) {
    if (isStarted) {
        throw new Error('already called setenv')
    }

    ;(Object.keys(CONFIG_DEFINITION) as CONFIG_KEYS[]).forEach(key => {
        const valueType = CONFIG_DEFINITION[key] || 'string'
        const parser = PARSERS[valueType]

        CONFIG[key] = parser(input[key])
    })

    isStarted = true
}

export function getenv<T extends CONFIG_KEYS>(name: T) {
    if (!isStarted) {
        throw new Error('attempted to getenv before setenv was called')
    }

    if (Object.prototype.hasOwnProperty.call(CONFIG, name)) {
        return CONFIG[name] as CONFIG_TYPE[T]
    }
    throw new Error(`no config named '${name}'`)
}
